import { Attachment } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconAttachment12Line = createIcon(Attachment, 12, "Line");
export const IconAttachment16Line = createIcon(Attachment, 16, "Line");
export const IconAttachment20Line = createIcon(Attachment, 20, "Line");
export const IconAttachment24Line = createIcon(Attachment, 24, "Line");
export const IconAttachment32Line = createIcon(Attachment, 32, "Line");
export const IconAttachment48Line = createIcon(Attachment, 48, "Line");
export const IconAttachment64Line = createIcon(Attachment, 64, "Line");
